const common: Record<string, string> = {
  // Nav
  'nav.solutions': 'Solutions',
  'nav.technology': 'Technology',
  'nav.advantages': 'Advantages',
  'nav.contact': 'Contact',
  'nav.getInfo': 'Get a Quote',
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.process': 'Process',
  'nav.vision': 'Vision',
  'nav.back': 'Back',

  // Hero
  'hero.badge': 'Innovative Baggage Repair Solution',
  'hero.title': 'Baggage Repair,',
  'hero.titleHighlight': 'reduce your dispute costs by 3',
  'hero.description': 'New professional damaged baggage repair service for airlines. Fast intervention, guaranteed quality, directly at Mohammed V hub.',
  'hero.ctaPrimary': 'Get a Quote',
  'hero.ctaSecondary': 'Discover Our Services',
  'hero.stat1': 'Cost Reduction',
  'hero.stat2': 'Repair Time',
  'hero.stat3': 'Satisfaction Goal',

  // Instant Impact
  'impact.title': 'Why pay to replace when you can repair?',
  'impact.card1Badge': 'Your current system',
  'impact.card1Highlight': 'Automatic replacement',
  'impact.card1Text': 'High costs + Heavy logistics + Ecological waste',
  'impact.card2Badge': 'Our local solution',
  'impact.card2Highlight': 'Express repair',
  'impact.card2Text': '-40% costs + Zero waste + Responsible brand image',
  'impact.cta': 'Calculate your savings',

  // Services
  'services.badge': 'Our Solutions',
  'services.title': 'Complete Solutions',
  'services.titleHighlight': 'For Your Passengers',
  'services.subtitle': 'A full range of repair services for all types of baggage damaged during air transport.',
  'services.fastTrack.title': 'Airport Fast-Track',
  'services.fastTrack.description': 'Express repair directly in the airport zone. 1-2h intervention to minimize impact on your passengers.',
  'services.fastTrack.feature1': '1-2 hour intervention',
  'services.fastTrack.feature2': 'Directly in airport zone',
  'services.fastTrack.feature3': 'Before/after photo report',
  'services.claims.title': 'Claims Management',
  'services.claims.description': 'Complete handling of baggage claims. From PIR declaration to final resolution.',
  'services.claims.feature1': 'Digitalized PIR declaration',
  'services.claims.feature2': 'Real-time tracking',
  'services.claims.feature3': 'Analytical reporting',
  'services.logistics.title': 'Logistics & Delivery',
  'services.logistics.description': 'Premium collection and delivery service. Your passengers get their repaired baggage wherever they want.',
  'services.logistics.feature1': 'Home or hotel collection',
  'services.logistics.feature2': 'Express delivery 24-48h',
  'services.logistics.feature3': 'Real-time GPS tracking',

  // Sovereignty
  'sovereignty.badge': 'Air Baggage Repair Competitive Advantage',
  'sovereignty.title': 'Repair vs Replacement',
  'sovereignty.subtitle': 'Why airlines choose Air Baggage Repair over costly replacement solutions',
  'sovereignty.competitorBadge': 'Traditional Solution',
  'sovereignty.competitorTitle': 'Systematic Replacement',
  'sovereignty.competitorSubtitle': 'The traditional competitor approach',
  'sovereignty.competitorPoint1': 'High cost: €250-500 per replaced baggage',
  'sovereignty.competitorPoint2': 'Long delay: 7-21 days waiting time',
  'sovereignty.competitorPoint3': 'Import dependency: Reliance on foreign suppliers',
  'sovereignty.competitorPoint4': 'Environmental impact: High waste and carbon footprint',
  'sovereignty.competitorPoint5': 'Low customer satisfaction: Passenger without baggage for days',
  'sovereignty.abrsBadge': 'ABRS Solution',
  'sovereignty.abrsTitle': 'Premium Local Repair',
  'sovereignty.abrsSubtitle': 'Our innovative and economical approach',
  'sovereignty.abrsPoint1': 'Estimated 88% savings: €30-60 per repair',
  'sovereignty.abrsPoint2': 'Extreme speed: 1-2h on-site at Mohammed V',
  'sovereignty.abrsPoint3': 'Local sovereignty: Moroccan expertise, zero dependency',
  'sovereignty.abrsPoint4': 'Eco-responsible: -80% carbon footprint, circular economy',
  'sovereignty.abrsPoint5': 'Maximum satisfaction: Passenger leaves with repaired baggage',
  'sovereignty.avgCostLabel': 'Average cost per incident',
  'sovereignty.roiTitle': 'Measurable Financial Impact',
  'sovereignty.roiSubtitle': 'Potential savings for your airline',
  'sovereignty.roiMetric1': 'Compensation cost reduction',
  'sovereignty.roiMetric2': 'Average resolution time',
  'sovereignty.roiMetric3': 'Customer satisfaction improvement',
  'sovereignty.exampleTitle': 'Concrete example for 100 baggage incidents/month:',
  'sovereignty.exampleText': 'Competitor replacement: €25,000-50,000/month • ABRS Repair: €3,000-6,000/month • Annual savings: €264,000-528,000 + brand image improvement',
  'sovereignty.certified': 'IATA Certified',
  'sovereignty.hub': 'Mohammed V Hub',
  'sovereignty.available': 'Available 24/7',
  'sovereignty.cta': 'Consult our technical protocol',

  // Engagement National
  'engagement.badge': 'National Commitment',
  'engagement.titlePart1': 'International expertise',
  'engagement.titlePart2': 'at the service of a',
  'engagement.titlePart3': 'Morocco that shines.',
  'engagement.description': 'As a Moroccan expatriate, I am proud to actively contribute to the growth of my country. Our project goes beyond simple economics: it creates local know-how, supports our provinces and positions the Kingdom as a leader in the circular economy.',
  'engagement.mapLabel': 'Kingdom of Morocco — All provinces',
  'engagement.keyPointsTitle': 'Key Points',
  'engagement.point1Title': 'Local Impact',
  'engagement.point1Desc': 'Creating sustainable jobs across all provinces.',
  'engagement.point2Title': 'Reducing Import Dependency',
  'engagement.point2Desc': 'Leveraging national resources and skills.',
  'engagement.point3Title': 'Technology Showcase',
  'engagement.point3Desc': 'Positioning Morocco as a model of responsible service.',

  // Reassurance
  'reassurance.badge': 'Why Choose Us',
  'reassurance.badge2': 'Our goal',
  'reassurance.title': 'A Trusted',
  'reassurance.titleHighlight': 'Partner',
  'reassurance.titleEnd': 'for Your Airline and Airport',
  'reassurance.description': 'We combine technical expertise, responsiveness and quality commitment to offer an unmatched baggage repair service to airlines.',
  'reassurance.point1Title': 'Express Responsiveness',
  'reassurance.point1Desc': '1-2h intervention directly at the airport hub. Your passengers leave with their repaired baggage the same day.',
  'reassurance.point2Title': 'Certified Quality',
  'reassurance.point2Desc': 'Full compliance with IATA standards. Each repair is documented and guaranteed for 6 months.',
  'reassurance.point3Title': 'Ecological Commitment',
  'reassurance.point3Desc': 'Repair rather than replace: -80% carbon footprint. A responsible circular approach.',

  // Process
  'process.badge': 'Our Process',
  'process.title': 'A Simple',
  'process.titleHighlight': 'and Efficient Process',
  'process.subtitle': 'From receiving the damaged baggage to its return, every step is optimized.',
  'process.step1Title': 'Report',
  'process.step1Desc': 'The passenger reports the damage at the counter. Our team is instantly alerted.',
  'process.step2Title': 'Diagnosis',
  'process.step2Desc': 'Complete baggage inspection with detailed photo report and transparent quote.',
  'process.step3Title': 'Repair',
  'process.step3Desc': 'Intervention by our certified technicians with quality parts and professional techniques.',
  'process.step4Title': 'Return',
  'process.step4Desc': 'Rigorous quality control then return of the repaired baggage to the satisfied passenger.',

  // Infographic
  'infographic.title': 'Before & After',
  'infographic.titleHighlight': 'ABRS',
  'infographic.subtitle': 'Discover the concrete impact of our solutions on damaged baggage management.',
  'infographic.beforeTitle': 'BEFORE ABRS',
  'infographic.beforeSubtitle': 'Traditional claims management',
  'infographic.afterTitle': 'AFTER ABRS',
  'infographic.afterSubtitle': 'Integrated DFPRO PARTNER solution',
  'infographic.metric1Label': 'Resolution time',
  'infographic.metric1Before': '7-21 days',
  'infographic.metric1After': '1-2 hours',
  'infographic.metric1Improvement': '-95%',
  'infographic.metric2Label': 'Passenger satisfaction',
  'infographic.metric2Before': '35%',
  'infographic.metric2After': '98%',
  'infographic.metric2Improvement': '+180%',
  'infographic.metric3Label': 'Environmental impact',
  'infographic.metric3Before': 'High',
  'infographic.metric3After': 'Minimal',
  'infographic.metric3Improvement': '-80%',
  'infographic.metric4Label': 'Brand image',
  'infographic.metric4Before': 'Degraded',
  'infographic.metric4After': 'Strengthened',
  'infographic.metric4Improvement': '+53%',
  'infographic.summaryLabel1': 'Repair time',
  'infographic.summaryLabel2': 'Cost reduction',
  'infographic.summaryLabel3': 'Customer satisfaction',
  'infographic.summaryLabel4': 'Carbon footprint',

  // Ecosystem
  'ecosystem.badge': 'Digital Ecosystem',
  'ecosystem.title': 'Our Technology',
  'ecosystem.titleHighlight': 'Platform',
  'ecosystem.subtitle': 'A complete digital ecosystem to manage, track and optimize every baggage repair.',
  'ecosystem.block1Title': 'Real-Time Repair Tracking',
  'ecosystem.block1Desc': 'Interactive dashboard to track every repair step. Automatic notifications, before/after photos and complete history accessible 24/7.',
  'ecosystem.block2Title': 'Digitalized PIR Entry',
  'ecosystem.block2Desc': 'Fully digital damage declaration form. Integrated photo capture, electronic signature and instant transmission to repair teams.',
  'ecosystem.block3Title': 'Reporting & Analytics',
  'ecosystem.block3Desc': 'Analytical dashboards with real-time KPIs. Trend analysis, forecasts and recommendations to optimize your baggage operations.',

  // Satisfaction Guarantee
  'guarantee.badge': 'Satisfaction Guarantee',
  'guarantee.title': 'Our Commitment to',
  'guarantee.titleHighlight': 'Total Quality',
  'guarantee.subtitle': 'Every ABRS repair is covered by our',
  'guarantee.subtitleBold': 'exclusive double guarantee',
  'guarantee.warrantyText1': '2-Year Warranty',
  'guarantee.warrantyText2': 'Even beyond manufacturer warranty',
  'guarantee.qualityBadge': 'IATA Certified Quality',
  'guarantee.step1Title': 'Parts & Labor Warranty',
  'guarantee.step1Desc': 'All our repairs are guaranteed for 2 years, parts and labor included. If a defect appears, we intervene free of charge.',
  'guarantee.step1Badge': 'Included',
  'guarantee.step2Title': 'Replacement if Irreparable',
  'guarantee.step2Desc': 'If the baggage is deemed irreparable after diagnosis, we ensure its replacement with an equivalent or superior model.',
  'guarantee.step2Badge': 'Premium',
  'guarantee.missionBadge': 'Our Mission',
  'guarantee.missionQuote': 'We don\'t just repair baggage, we restore',
  'guarantee.missionHighlight1': 'trust',
  'guarantee.missionAnd': 'and',
  'guarantee.missionHighlight2': 'peace of mind',
  'guarantee.missionEnd': 'for every passenger. That\'s our',
  'guarantee.missionHighlight3': 'daily commitment',
  'guarantee.trustIndicator1': 'IATA Certified',
  'guarantee.trustIndicator2': 'Available 24/7',
  'guarantee.trustIndicator3': '98% Satisfaction',

  // Partners
  'partners.badge': 'Our Values',
  'partners.title': 'Excellence at the Service',
  'partners.titleHighlight': 'of Aviation',
  'partners.subtitle': 'Strong values that guide each of our interventions and guarantee exceptional service.',
  'partners.value1Title': 'Responsiveness',
  'partners.value1Desc': '1-2h intervention',
  'partners.value2Title': 'Reliability',
  'partners.value2Desc': 'IATA Certified',
  'partners.value3Title': 'Support',
  'partners.value3Desc': 'Available 24/7',
  'partners.value4Title': 'Logistics',
  'partners.value4Desc': 'Premium delivery',
  'partners.stat1': 'Satisfaction goal',
  'partners.stat2': 'Availability',
  'partners.stat3': 'Innovative solution',
  'partners.trustBadge': 'New solution for airlines',

  // Testimonial
  'testimonial.badge': 'IATA Certified',
  'testimonial.badgeDesc': 'Full compliance',
  'testimonial.quote': 'ABRS offers an innovative solution to transform baggage claims management. Our',
  'testimonial.quoteHighlight': 'responsiveness and expertise',
  'testimonial.quoteEnd': ' will enable you to reduce your costs by up to 65% while improving passenger satisfaction.',
  'testimonial.optimizedFor': 'Optimized for airlines',
  'testimonial.companies': 'Professional B2B solution',
  'testimonial.readyFor': 'Ready for your airline',
  'testimonial.value1Title': 'Significant Savings',
  'testimonial.value1Desc': 'Estimated 88% cost reduction compared to systematic replacement.',
  'testimonial.value2Title': 'Guaranteed Compliance',
  'testimonial.value2Desc': 'Complete documentation and traceability for every intervention.',
  'testimonial.value3Title': 'Environmental Impact',
  'testimonial.value3Desc': '-80% carbon footprint through repair rather than replacement.',

  // Eco Impact
  'ecoImpact.badge': 'Environmental Impact',
  'ecoImpact.title': 'Our',
  'ecoImpact.titleHighlight': 'Ecological Commitment',
  'ecoImpact.subtitle': 'Every repaired baggage is a baggage saved from landfill. Our circular approach significantly reduces the carbon footprint.',
  'ecoImpact.metric1': 'Repair goal',
  'ecoImpact.metric2': 'Waste avoided per year',
  'ecoImpact.metric3': 'CO₂ saved per year',
  'ecoImpact.metric4': 'Target repairability rate',
  'ecoImpact.metric5': 'Satisfaction goal',
  'ecoImpact.noteTitle': 'Circular economy:',
  'ecoImpact.noteText': 'Every repair helps reduce waste and the carbon footprint of the aviation industry.',

  // International Presence
  'international.heroBadge': 'Moroccan Pride',
  'international.heroTitle': 'Born in Morocco,',
  'international.heroTitleHighlight': 'Shining Internationally',
  'international.heroDesc': 'From Casablanca, we export our know-how and excellence to Europe and the world.',
  'international.badge': 'International Presence',
  'international.title': 'An Expanding',
  'international.titleHighlight': 'Network',
  'international.subtitle': 'Two complementary expertise hubs to serve airlines around the world.',
  'international.europeTitle': 'DFPRO EUROPE',
  'international.europeSubtitle': 'European HQ \u2014 Belgium',
  'international.europeDesc': 'Our European subsidiary manages operations at the continent\'s main hubs, with recognized expertise in baggage claims management.',
  'international.europePoint1': 'Presence at Brussels, Charleroi, Geneva airports',
  'international.europePoint2': 'Partnerships with European airlines',
  'international.europePoint3': 'EU regulatory compliance',
  'international.internationalTitle': 'Global Expansion',
  'international.internationalSubtitle': 'Gibraltar, USA, UAE',
  'international.internationalDesc': 'Our expertise extends beyond Europe with operations in North America, the Middle East and Africa.',
  'international.internationalPoint1': 'Presence in Gibraltar, Houston (Texas), Dubai',
  'international.internationalPoint2': 'Adaptation to local standards',
  'international.internationalPoint3': 'Multilingual 24/7 support',

  // CTA
  'cta.badge': 'Take Action',
  'cta.title': 'Ready to Optimize',
  'cta.titleHighlight': 'Your Baggage Costs?',
  'cta.description': 'Contact us for a personalized study and discover how much you can save with ABRS.',
  'cta.benefit1': 'Estimated 88% reduction in claims costs',
  'cta.benefit2': 'Express intervention in 1-2 hours',
  'cta.benefit3': 'Real-time tracking platform',
  'cta.benefit4': 'Guaranteed IATA compliance',
  'cta.ctaPrimary': 'Get a Free Quote',
  'cta.ctaSecondary': 'Download Our Brochure',
  'cta.deploymentTitle': 'Launching soon',
  'cta.deploymentDesc': 'Deployment in progress',

  // Footer
  'footer.tagline': 'Airport baggage repair expert.',
  'footer.description': 'Professional, fast and guaranteed service for airlines. International presence with headquarters in Morocco.',
  'footer.newsletterTitle': 'Stay Informed',
  'footer.newsletterDesc': 'Receive our news and innovations in baggage repair.',
  'footer.newsletterPlaceholder': 'Your professional email',
  'footer.newsletterSuccess': 'Successfully subscribed!',
  'footer.teamTitle': 'Our Team at Your Service',
  'footer.teamDesc': 'A passionate and expert team, dedicated to service excellence.',
  'footer.contactTitle': 'Our International Offices',
  'footer.contactBelgium': 'Belgium',
  'footer.contactMorocco': 'Morocco',
  'footer.contactEmailBelgium': 'Belgium Email',
  'footer.contactEmailMorocco': 'Morocco Email',
  'footer.solutionsTitle': 'Solutions',
  'footer.solution1': 'Airport Fast-Track',
  'footer.solution2': 'Claims Management',
  'footer.solution3': 'Premium Logistics',
  'footer.solution4': 'SaaS Platform',
  'footer.companyTitle': 'Company',
  'footer.company1': 'About Us',
  'footer.company2': 'Careers',
  'footer.company3': 'Partners',
  'footer.company4': 'Press',
  'footer.resourcesTitle': 'Resources',
  'footer.resource1': 'Documentation',
  'footer.resource2': 'Blog',
  'footer.resource3': 'FAQ',
  'footer.resource4': 'Support',
  'footer.copyright': 'All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms & Conditions',
  'footer.poweredBy': 'Powered by Readdy',

  // Contact Page
  'contactPage.heroBadge': 'Contact Us',
  'contactPage.heroTitle': 'Let\'s Talk About Your',
  'contactPage.heroTitleHighlight': 'Project Together',
  'contactPage.heroDesc': 'Our team of experts is at your disposal to study your needs and offer you a tailored solution.',
  'contactPage.info1Title': 'Our Offices',
  'contactPage.info2Title': 'Phone',
  'contactPage.info3Title': 'Email',
  'contactPage.info4Title': 'Hours',
  'contactPage.info4Line1': 'Mon-Fri: 8:00 AM - 6:00 PM',
  'contactPage.info4Line2': 'Emergencies: 24/7',
  'contactPage.formSideTitle': 'Why Choose',
  'contactPage.formSideTitleHighlight': 'ABRS?',
  'contactPage.formSideDesc': 'Discover the concrete advantages of a partnership with Air Baggage Repair Solutions.',
  'contactPage.advantage1Title': 'Response in 24h',
  'contactPage.advantage1Desc': 'Our sales team responds within 24 business hours.',
  'contactPage.advantage2Title': 'Estimated 88% Savings',
  'contactPage.advantage2Desc': 'Drastic cost reduction compared to replacement.',
  'contactPage.advantage3Title': 'IATA Certified',
  'contactPage.advantage3Desc': 'Full compliance with international standards.',
  'contactPage.advantage4Title': 'Dedicated Support',
  'contactPage.advantage4Desc': 'A dedicated account manager for your airline.',
  'contactPage.advantage5Title': 'Complete Reporting',
  'contactPage.advantage5Desc': 'Real-time dashboards and analytics.',
  'contactPage.urgencyLabel': 'Emergency Line',
  'contactPage.urgencyDesc': 'For airport emergencies, our teams are available 24/7.',
  'contactPage.formTitle': 'Request a Quote',
  'contactPage.formSubtitle': 'Fill out the form below and we will get back to you quickly.',
  'contactPage.labelFirstName': 'First Name',
  'contactPage.placeholderFirstName': 'Your first name',
  'contactPage.labelLastName': 'Last Name',
  'contactPage.placeholderLastName': 'Your last name',
  'contactPage.labelEmail': 'Email',
  'contactPage.placeholderEmail': 'your@email.com',
  'contactPage.labelPhone': 'Phone',
  'contactPage.placeholderPhone': '+32 ...',
  'contactPage.labelCompany': 'Company',
  'contactPage.placeholderCompany': 'Your company name',
  'contactPage.labelPosition': 'Position',
  'contactPage.placeholderPosition': 'Your role',
  'contactPage.labelService': 'Desired Service',
  'contactPage.selectService': 'Select a service',
  'contactPage.labelVolume': 'Estimated Volume',
  'contactPage.selectVolume': 'Select a volume',
  'contactPage.labelMessage': 'Message',
  'contactPage.placeholderMessage': 'Describe your needs...',
  'contactPage.charCount': 'characters',
  'contactPage.rgpdText': 'I agree that my data will be processed in accordance with the',
  'contactPage.rgpdLink': 'privacy policy',
  'contactPage.submitting': 'Sending...',
  'contactPage.submitButton': 'Send my request',
  'contactPage.errorMessage': 'An error occurred. Please try again.',
  'contactPage.successTitle': 'Request Sent!',
  'contactPage.successDesc': 'Our team will contact you within 24 business hours.',
  'contactPage.successButton': 'Send another request',

  // Services Page
  'servicesPage.heroBadge': 'Our Professional Services',
  'servicesPage.heroTitle': 'Complete Baggage',
  'servicesPage.heroTitleHighlight': 'Repair Solutions',
  'servicesPage.heroDesc': 'A full range of B2B services for airlines, from express repair to integrated claims management.',
  'servicesPage.heroCtaPrimary': 'Get a Quote',
  'servicesPage.heroCtaSecondary': 'Call Us',
  'servicesPage.listTitle': 'Our Services',
  'servicesPage.listTitleHighlight': 'in Detail',
  'servicesPage.listSubtitle': 'Discover all our solutions tailored to airline needs.',
  'servicesPage.service1Title': 'Airport Fast-Track',
  'servicesPage.service1Desc': 'Express repair directly in the airport zone. Our team intervenes in 1-2h to minimize impact on your passengers and operations.',
  'servicesPage.service1Feature1': '1-2 hour on-site intervention',
  'servicesPage.service1Feature2': 'Mobile workshop in airport zone',
  'servicesPage.service1Feature3': 'Before/after photo report',
  'servicesPage.service1Feature4': 'Premium spare parts',
  'servicesPage.service2Title': 'Claims Management',
  'servicesPage.service2Desc': 'Complete handling of baggage claims, from PIR declaration to final resolution with detailed reporting.',
  'servicesPage.service2Feature1': 'Digitalized PIR declaration',
  'servicesPage.service2Feature2': 'Real-time tracking',
  'servicesPage.service2Feature3': 'Automated passenger communication',
  'servicesPage.service2Feature4': 'Monthly analytical reporting',
  'servicesPage.service3Title': 'Maintenance Contract',
  'servicesPage.service3Desc': 'Preventive and corrective maintenance program to optimize baggage equipment lifespan.',
  'servicesPage.service3Feature1': 'Scheduled regular inspections',
  'servicesPage.service3Feature2': 'Preventive maintenance',
  'servicesPage.service3Feature3': 'Wear parts replacement',
  'servicesPage.service3Feature4': 'Quarterly status report',
  'servicesPage.service4Title': 'Logistics & Delivery',
  'servicesPage.service4Desc': 'Premium collection and delivery service. Your passengers get their repaired baggage wherever they want.',
  'servicesPage.service4Feature1': 'Home or hotel collection',
  'servicesPage.service4Feature2': 'Express delivery 24-48h',
  'servicesPage.service4Feature3': 'Real-time GPS tracking',
  'servicesPage.service4Feature4': 'Secure packaging',
  'servicesPage.service5Title': 'Repair Workshop',
  'servicesPage.service5Desc': 'Our central workshop equipped with the latest technologies for complex repairs requiring a controlled environment.',
  'servicesPage.service5Feature1': 'State-of-the-art professional equipment',
  'servicesPage.service5Feature2': 'Certified technicians',
  'servicesPage.service5Feature3': 'Spare parts inventory',
  'servicesPage.service5Feature4': 'Rigorous quality control',
  'servicesPage.service6Title': 'Custom Solutions',
  'servicesPage.service6Desc': 'Personalized solutions adapted to the specific needs of your airline.',
  'servicesPage.service6Feature1': 'Audit of your current processes',
  'servicesPage.service6Feature2': 'Tailored solution proposal',
  'servicesPage.service6Feature3': 'Integration with your systems',
  'servicesPage.service6Feature4': 'Team training',
  'servicesPage.learnMore': 'Learn More',
  'servicesPage.pricingBadge': 'Pricing',
  'servicesPage.pricingTitle': 'Plans',
  'servicesPage.pricingTitleHighlight': 'Tailored',
  'servicesPage.pricingTitleEnd': 'to Your Needs',
  'servicesPage.pricingSubtitle': 'Choose the plan that best matches your volume and needs.',
  'servicesPage.plan1Name': 'Essential',
  'servicesPage.plan1Desc': 'For airlines with moderate volume',
  'servicesPage.plan1Price': 'Custom Quote',
  'servicesPage.plan2Name': 'Business',
  'servicesPage.plan2Desc': 'The most popular solution',
  'servicesPage.plan2Price': 'Custom Quote',
  'servicesPage.plan3Name': 'Enterprise',
  'servicesPage.plan3Desc': 'For major airlines',
  'servicesPage.plan3Price': 'Custom Quote',
  'servicesPage.recommended': 'Recommended',
  'servicesPage.planCta': 'Get a Quote',
  'servicesPage.pricingNote': 'All prices are customized based on your volume and specific needs.',
  'servicesPage.processBadge': 'Our Process',
  'servicesPage.processTitle': 'How It',
  'servicesPage.processTitleHighlight': 'Works',
  'servicesPage.processSubtitle': 'A simple and transparent 4-step process.',
  'servicesPage.processStep1': 'Diagnosis',
  'servicesPage.processStep1Desc': 'Complete baggage inspection and detailed damage assessment.',
  'servicesPage.processStep2': 'Quote',
  'servicesPage.processStep2Desc': 'Repair proposal with transparent and detailed quote.',
  'servicesPage.processStep3': 'Repair',
  'servicesPage.processStep3Desc': 'Intervention by our certified technicians with quality parts.',
  'servicesPage.processStep4': 'Delivery',
  'servicesPage.processStep4Desc': 'Quality control and return of the repaired baggage.',
  'servicesPage.ctaBadge': 'Ready to Start?',
  'servicesPage.ctaTitle': 'Optimize Your',
  'servicesPage.ctaTitleHighlight': 'Baggage Management',
  'servicesPage.ctaTitleEnd': 'Today',
  'servicesPage.ctaDesc': 'Contact our team for a personalized study of your needs.',
  'servicesPage.ctaPrimary': 'Get a Quote',
  'servicesPage.ctaSecondary': 'Call Us',
  'servicesPage.trustIndicator1': 'IATA Certified',
  'servicesPage.trustIndicator2': 'Available 24/7',
  'servicesPage.trustIndicator3': 'International presence',
};

export default common;
